module.exports = __webpack_public_path__ + "img/logo-event-mobile.2df015bf.svg";